import { FC } from 'react';
import Link from 'next/link';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { getAuthorFullName, hideImgOnError, getTruncatedTxt } from '@/helpers/helpers';
import { IBlogBooksGenre } from '@/interfaces/blogBooks.interface';
// import RatingView from '@/components/ui/rating-view/RatingView';
import styles from './BlogBook.module.scss';

interface IBlogBook {
  id: number;
  externalId: number;
  alias: string;
  rating: number;
  title: string;
  authorFirstName: string;
  authorMiddleName: string;
  authorLastName: string;
  authorAlias: number;
  reviews: number;
}

const BlogBook: FC<IBlogBook> = ({ id, externalId, alias, rating, title, authorFirstName, authorMiddleName, authorLastName, authorAlias, reviews }) => {
  const authorLink = `/author/id${authorAlias}`;
  const bookLink = `/lib/id${alias}`;
  const authorName = getAuthorFullName(authorFirstName, authorMiddleName, authorLastName);
  const bookCover = `${DEV_ABSOLUTE_URL}/covers/${externalId}.jpg`;

  return (
    <div key={id} className={styles.blogBook}>
      <div className={styles.blogBook__imgWrap}>
        <Link prefetch={false} className={styles.blogBook__imgLink} href={bookLink}>
          <img className={styles.blogBook__img} src={bookCover} width="110" height="140" alt={title} onError={hideImgOnError} />
        </Link>
      </div>

      <div className={styles.blogBook__stats}>
        <div className={styles.blogBook__rating}>{rating}</div>
        <div className={styles.blogBook__review}>{reviews}</div>
      </div>
      <Link prefetch={false} href={authorLink} className={styles.blogBook__author}>
        {authorName}
      </Link>
      <Link prefetch={false} className={styles.blogBook__name} href={bookLink}>
        {getTruncatedTxt(title, 40)}
      </Link>
    </div>
  );
};
export default BlogBook;
